import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container } from "react-bootstrap";
import { useParams } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { loadCMSData } from "./Slice/cmsSlice";

const Index = () => {

  const { slug } = useParams();
  const dispatch = useDispatch();
  const { cmsData } = useSelector((state) => state?.cms);
  const setting = useSelector((state) => state?.setting);
  const siteName = setting?.name?.trim() || "";

  const prepareHtml = (description) => {
    return { __html: description || "" };
  };

  useEffect(() => {
    if (slug) {
      dispatch(loadCMSData(slug));
    }
  }, [dispatch, slug]);

  useEffect(() => {
    window.scrollTo(0, 0);

    // Decide page title dynamically
    let pageTitle = cmsData?.meta_title;

    if (!pageTitle) {
      if (slug === "privacy-policy") {
        pageTitle = "Privacy Policy";
      } else if (slug === "terms-and-conditions") {
        pageTitle = "Terms & Conditions";
      } else {
        pageTitle = "Page";
      }
    }

    document.title = `${siteName} - ${pageTitle}`;

    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc && cmsData?.meta_description) {
      metaDesc.setAttribute("content", cmsData.meta_description);
    }
  }, [siteName, slug, cmsData?.meta_title, cmsData?.meta_description]);


  return (
    <section className="about_content_mian">
      <Container>
        <div className="cms_content">
          <h1 className="title pb-5">{cmsData?.title}</h1>
          <div
            dangerouslySetInnerHTML={prepareHtml(cmsData?.description)}
          ></div>
        </div>
      </Container>
    </section>
  );
};

export default Index;
